export default (className = '.header', offset = 50) => {
	const el = document.querySelector(className)
	document.addEventListener('scroll', () => {
		if (window.pageYOffset > offset) {
			el.classList.add('--shrink')
		} else {
			el.classList.remove('--shrink')
		}
	})
}
